import React, { useEffect, useState } from "react";
import api from "../../api/config";
import { Tooltip } from "react-tooltip";
import "@fortawesome/fontawesome-free/css/all.min.css";

function GuestDescriptionForm({ details, setDetails }) {
  const [businessList, setBusinessList] = useState([]);

  // Business Type 목록 불러오기
  useEffect(() => {
    const fetchBusinessList = async () => {
      try {
        const res = await api.get("/business-type");
        if (res?.data?.status === 200) {
          setBusinessList(res.data.response);
        }
      } catch (error) {
        console.log("Error fetching business list");
      }
    };

    fetchBusinessList();
  }, []);

  const handleChange = (e) => {
    setDetails({ ...details, [e.target.name]: e.target.value });
  };

  return (
    <>
      <div className="col-md-9">
        <div className="m-5">
          <div className="card">
            <div className="card-header">
              <h5 className="bold">Property Details</h5>
            </div>

            <div className="card-body">

              {/* Rent */}
              <div className="row">
                <div className="form-group col-md-5 col-sm-12">
                  <label htmlFor="rentfee">
                    Monthly Sublet Rent
                    <span className="text-danger" style={{ marginLeft: "5px" }}>
                      *
                    </span>
                    <i
                      className="fas fa-info-circle"
                      data-tooltip-id="rent-tooltip"
                    ></i>
                    <Tooltip id="rent-tooltip">Sublet Rent (Monthly)</Tooltip>
                  </label>

                  <input
                    type="number"
                    name="rent"
                    value={details.rent || ""}
                    onChange={handleChange}
                    className="form-control"
                    id="rentfee"
                    placeholder="Sublet Rent (Monthly)"
                  />
                </div>
              </div>

              {/* Total SQFT */}
              <div className="row mt-3">
                <div className="form-group col-md-4 col-sm-12">
                  <label htmlFor="totalSQFT">
                    Total SQFT
                    <span className="text-danger" style={{ marginLeft: "5px" }}>
                      *
                    </span>
                    <i
                      className="fas fa-info-circle"
                      data-tooltip-id="totalSpace-tooltip"
                    ></i>
                    <Tooltip id="totalSpace-tooltip">
                      Available SQFT (Current Business’ Available Sublet Space)
                    </Tooltip>
                  </label>

                  <input
                    type="number"
                    name="totalSpace"
                    value={details.totalSpace || ""}
                    onChange={handleChange}
                    className="form-control"
                    id="totalSQFT"
                    placeholder="Enter Available SQFT"
                  />
                </div>
              </div>

              {/* Remaining Lease Term */}
              <div className="row mt-3">
                <div className="form-group col-md-4 col-sm-12">
                  <label htmlFor="leaseTerm">
                    Remaining Lease Term
                    <span className="text-danger" style={{ marginLeft: "5px" }}>
                      *
                    </span>
                    <i
                      className="fas fa-info-circle"
                      data-tooltip-id="remainingLeaseTerm-tooltip"
                    ></i>
                    <Tooltip id="remainingLeaseTerm-tooltip">
                      Current Business’ Remaining Lease Term (Month)
                    </Tooltip>
                  </label>

                  <input
                    type="number"
                    name="remainingLeaseTerm"
                    value={details.remainingLeaseTerm || ""}
                    onChange={handleChange}
                    className="form-control"
                    id="leaseTerm"
                    placeholder="Enter Remaining Lease Term"
                  />
                </div>
              </div>

              {/* Business Type */}
              <div className="row mt-3">
                <div className="form-group col-md-4 col-sm-12">
                  <label htmlFor="businessType">
                    Business Type
                    <span className="text-danger" style={{ marginLeft: "5px" }}>
                      *
                    </span>
                    <i
                      className="fas fa-info-circle"
                      data-tooltip-id="businessType-tooltip"
                    ></i>
                    <Tooltip id="businessType-tooltip">
                      Current Business Type
                    </Tooltip>
                  </label>

                  <input
                    type="text"
                    name="businessType"
                    value={details.businessType || ""}
                    onChange={handleChange}
                    className="form-control"
                    id="businessType"
                    placeholder="Enter Business Type"
                    autoComplete="on"
                    list="businessTypeList"
                  />

                  <datalist id="businessTypeList">
                    {businessList?.map((item) => (
                      <option key={item?.id} value={item?.name}>
                        {item?.name}
                      </option>
                    ))}
                  </datalist>
                </div>
              </div>

              {/* Description */}
              <div className="row mt-3">
                <div className="form-group col-md-9 col-sm-12">
                  <label htmlFor="Description">
                    Description
                    <span className="text-danger" style={{ marginLeft: "5px" }}>
                      *
                    </span>
                    <Tooltip id="description-tooltip">
                      Detailed description of the property
                    </Tooltip>
                  </label>

                  <textarea
                    name="description"
                    maxLength={1000}
                    value={details.description || ""}
                    onChange={handleChange}
                    placeholder="Enter Description"
                    className="form-control"
                    rows={7}
                  />
                </div>
              </div>

              {/* Edit 페이지에서는 Next 버튼 없음 */}

            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default GuestDescriptionForm;